import { Price } from 'components/cart/Price';
import type { Variant } from 'types/product/Variant';

import type { BaseConfiguratorProps } from '.';
import { Wrapper } from './Wrapper';

interface OTPSingleVariantProps extends BaseConfiguratorProps {
  variant: Variant;
  availableForSale: boolean;
  otpVariant: Variant;
}

export function OTPSingleVariant({
  variant,
  showSavingsAsAmount,
  isDiscountHidden,
  ...props
}: OTPSingleVariantProps) {
  return (
    <Wrapper
      className="product_otpSingleVariant"
      variant={variant}
      isDiscountHidden={isDiscountHidden}
      {...props}
    >
      <Price
        size="h4"
        isSavingVisible
        totalAmount={variant.price}
        subtotalAmount={
          !isDiscountHidden && variant.availableForSale
            ? variant.compareAtPrice
            : undefined
        }
        showSavingsAsAmount={showSavingsAsAmount}
      />
    </Wrapper>
  );
}
